import { render, staticRenderFns } from "./OtpResetPassword.vue?vue&type=template&id=5302d21f&scoped=true&"
import script from "./OtpResetPassword.vue?vue&type=script&lang=js&"
export * from "./OtpResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./OtpResetPassword.vue?vue&type=style&index=0&id=5302d21f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5302d21f",
  null
  
)

export default component.exports